import { RoleTypeNameConstant } from 'constants/code.constant';
import useAccount from 'hooks/useAccount';
import MainLayout from 'layouts/MainLayout';
import { useSearchParams } from 'react-router-dom';
import CommonUtil from 'utils/common.util';

const AdminClientDetail = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');

  const { useGetAccount } = useAccount();
  const { accountInfo } = useGetAccount(code);

  if (!accountInfo) return;

  return (
    <MainLayout>
      <div className="page-header">기업 상세</div>
      <div className="page-card">
        <div className="table-search-wrap detail-form-wrap">
          <div>
            <label>이메일</label>
            <p className="text">{accountInfo.email}</p>
          </div>
          <div>
            <label>권한유형</label>
            <p className="text">{RoleTypeNameConstant[accountInfo.roleType]}</p>
          </div>
          <div>
            <label>기업명</label>
            <p className="text">{accountInfo.company}</p>
          </div>
          <div>
            <label>기업형태</label>
            <p className="text">{accountInfo.companyType}</p>
          </div>
          <div>
            <label>사업자등록번호</label>
            <p className="text">{accountInfo.companyNumber}</p>
          </div>
          <div>
            <label>법인(주민)등록번호</label>
            <p className="text">{accountInfo.corporateRegistrationNumber}</p>
          </div>
          <div>
            <label>법인설립일</label>
            <p className="text">{accountInfo.corporateEstablishmentAt}</p>
          </div>
          <div>
            <label>분야</label>
            <p className="text">{accountInfo.field}</p>
          </div>
          <div>
            <label>주요생산품</label>
            <p className="text">{accountInfo.mainProduction}</p>
          </div>
          <div>
            <label>홈페이지 링크</label>
            {accountInfo.companyHomepageLink && (
              <p className="link" onClick={() => window.open(accountInfo.companyHomepageLink, '_blank')}>
                {accountInfo.companyHomepageLink}
              </p>
            )}
          </div>
        </div>
      </div>
      <br />
      <div className="page-header">대표자 정보</div>
      <div className="page-card">
        <div className="table-search-wrap detail-form-wrap">
          <div>
            <label>대표자 성명</label>
            <p className="text">{accountInfo.ceoEmail}</p>
          </div>
          <div>
            <label>대표자 성별</label>
            <p className="text">{accountInfo.ceoGender}</p>
          </div>
          <div>
            <label>대표자 생년월일</label>
            <p className="text">{accountInfo.ceoBirthday}</p>
          </div>
          <div>
            <label>대표자 연락처</label>
            <p className="text">{accountInfo.ceoPhoneNumber}</p>
          </div>
          <div>
            <label>대표자 이메일</label>
            <p className="text">{accountInfo.ceoEmail}</p>
          </div>
          <div />
          <div>
            <label>공동 대표자 성명</label>
            <p className="text">{accountInfo.coCeoName}</p>
          </div>
          <div>
            <label>공동 대표자 성별</label>
            <p className="text">{accountInfo.coCeoGender}</p>
          </div>
          <div>
            <label>공동 대표자 생년월일</label>
            <p className="text">{accountInfo.coCeoBirthday}</p>
          </div>
          <div>
            <label>공동 대표자 연락처</label>
            <p className="text">{accountInfo.coCeoPhoneNumber}</p>
          </div>
        </div>
      </div>
      <br />
      <div className="page-header">담당자 정보</div>
      <div className="page-card">
        <div className="table-search-wrap detail-form-wrap">
          <div>
            <label>담당자 성명</label>
            <p className="text">{accountInfo.name}</p>
          </div>
          <div>
            <label>담당자 직급</label>
            <p className="text">{accountInfo.position}</p>
          </div>
          <div>
            <label>담당자 연락처</label>
            <p className="text">{accountInfo.phoneNumber}</p>
          </div>
        </div>
      </div>
      <br />
      <div className="page-header">기업성과</div>
      <div className="page-card">
        <div className="table-search-wrap detail-form-wrap">
          <div>
            <label>벤처인증번호</label>
            <p className="text">{accountInfo.ventureRegistrationNumber}</p>
          </div>
          <div>
            <label>벤처인증일</label>
            <p className="text">{accountInfo.ventureCertificationAt}</p>
          </div>
          <div>
            <label>매출</label>
            <div>
              <h4
                style={{
                  marginBottom: '5px',
                }}
              >
                총 매출:{' '}
                {CommonUtil.tsCommaFormat(
                  accountInfo.salesList.reduce((acc, sale) => acc + (sale.domesticSales + sale.overseasSales), 0),
                )}
                원
              </h4>
              <div className="table-wrap">
                <table
                  style={{
                    margin: 0,
                  }}
                >
                  <thead>
                    <tr>
                      <td>년도</td>
                      <td>국내(원)</td>
                      <td>해외(원)</td>
                      <td>합계(원)</td>
                    </tr>
                  </thead>
                  <tbody>
                    {accountInfo.salesList.length === 0 && (
                      <tr>
                        <td colSpan={4}>결과가 없습니다.</td>
                      </tr>
                    )}
                    {accountInfo.salesList.map((item, index) => (
                      <tr key={index}>
                        <td>{item.year}</td>
                        <td>{CommonUtil.tsCommaFormat(item.domesticSales)}</td>
                        <td>{CommonUtil.tsCommaFormat(item.overseasSales)}</td>
                        <td>{CommonUtil.tsCommaFormat(parseInt(item.domesticSales) + parseInt(item.overseasSales))}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div>
            <label>고용 (4대보험 가입 기준 / 대표자 제외)</label>
            <div>
              <h4
                style={{
                  marginBottom: '5px',
                }}
              >
                총 인원:{' '}
                {CommonUtil.tsCommaFormat(
                  accountInfo.employmentList.reduce(
                    (acc, employee) => acc + (employee.permanentEmployees + employee.temporaryEmployees),
                    0,
                  ),
                )}
                명
              </h4>
              <div className="table-wrap">
                <table
                  style={{
                    margin: 0,
                  }}
                >
                  <thead>
                    <tr>
                      <td>년도</td>
                      <td>정규직(명)</td>
                      <td>비정규직(명)</td>
                      <td>합계(명)</td>
                    </tr>
                  </thead>
                  <tbody>
                    {accountInfo.employmentList.length === 0 && (
                      <tr>
                        <td colSpan={4}>결과가 없습니다.</td>
                      </tr>
                    )}
                    {accountInfo.employmentList.map((item, index) => (
                      <tr key={index}>
                        <td>{item.year}</td>
                        <td>{CommonUtil.tsCommaFormat(item.permanentEmployees)}</td>
                        <td>{CommonUtil.tsCommaFormat(item.temporaryEmployees)}</td>
                        <td>
                          {CommonUtil.tsCommaFormat(
                            parseInt(item.permanentEmployees) + parseInt(item.temporaryEmployees),
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div>
            <label>투자</label>
            <div>
              <h4
                style={{
                  marginBottom: '5px',
                }}
              >
                총 투자 금액:{' '}
                {CommonUtil.tsCommaFormat(
                  accountInfo.investmentList.reduce((acc, investment) => acc + investment.investmentAmount, 0),
                )}
                원
              </h4>
              <div className="table-wrap">
                <table
                  style={{
                    margin: 0,
                  }}
                >
                  <thead>
                    <tr>
                      <td>년도</td>
                      <td>투자금액(원)</td>
                      <td>투자자</td>
                    </tr>
                  </thead>
                  <tbody>
                    {accountInfo.investmentList.length === 0 && (
                      <tr>
                        <td colSpan={3}>결과가 없습니다.</td>
                      </tr>
                    )}
                    {accountInfo.investmentList.map((item, index) => (
                      <tr key={index}>
                        <td>{item.year}</td>
                        <td>{CommonUtil.tsCommaFormat(item.investmentAmount)}</td>
                        <td>{item.investor}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div>
            <label>특허</label>
            <div>
              <h4
                style={{
                  marginBottom: '5px',
                }}
              >
                총 특허 수: {CommonUtil.tsCommaFormat(accountInfo.patentList.length)}개
              </h4>
              <div className="table-wrap">
                <table
                  style={{
                    margin: 0,
                  }}
                >
                  <thead>
                    <tr>
                      <td>특허 유형</td>
                      <td>특허 상태</td>
                      <td>출원 번호</td>
                      <td>특허명</td>
                    </tr>
                  </thead>
                  <tbody>
                    {accountInfo.patentList.length === 0 && (
                      <tr>
                        <td colSpan={4}>결과가 없습니다.</td>
                      </tr>
                    )}
                    {accountInfo.patentList.map((item, index) => (
                      <tr key={index}>
                        <td>{item.patentType}</td>
                        <td>{item.patentStatus}</td>
                        <td>{item.patentNumber}</td>
                        <td>{item.patentName}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default AdminClientDetail;
